import React from 'react';
import DistancePicker from '../shared/DistancePicker';

interface StepProps {
  answer: any;
  onAnswer: (value: any) => void;
  answers: Record<string, any>;
}

const RunClubDistanceStep: React.FC<StepProps> = ({ answer, onAnswer }) => {
  return (
    <DistancePicker
      value={answer && typeof answer === 'object' ? answer : null}
      onChange={onAnswer}
    />
  );
};

export default RunClubDistanceStep;
